import type { DocumentView, StatementOption } from '../../types';

// Distinct codes within the strongest evidence tier present: statements of the product's
// own formulation, else statements naming the product, else everything. Generic tank-mix
// instructions ("add wettable powders before emulsifiable concentrates") mention many
// formulations and must not read as a contradiction. More than one code = contradiction.
export const getSuggestedCodes = (documents: DocumentView[]): string[] => {
    const statements = documents.flatMap(document => document.statements);
    const tiers: ((option: StatementOption) => boolean)[] = [
        option => option.selfStatement,
        option => option.mentionsProduct,
        () => true
    ];
    const codesInTier = (isInTier: (option: StatementOption) => boolean): string[] => [
        ...new Set(
            statements
                .filter(isInTier)
                .flatMap(option =>
                    option.suggestedCode ? [option.suggestedCode.toUpperCase()] : []
                )
        )
    ];

    return (tiers.map(codesInTier).find(codes => codes.length > 0) ?? []).sort();
};
